import { render } from "./AppModalSelector.vue?vue&type=template&id=08924c98"
import script from "./AppModalSelector.vue?vue&type=script&lang=js"
export * from "./AppModalSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__